import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgWorkshop = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#85E3F9"
      fillRule="evenodd"
      d="M8 11h24v20H8z"
      clipRule="evenodd"
    />
    <path
      fill="#00C5F2"
      d="M20 19h-7v12h7zM32 10H8v4h24z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgWorkshop);

export default ForwardRef;
